module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/founder/1-mobile-2a16be716f060a17fcca1e93c75fec29.jpg";